import frontDeskSVG from "assets/img/frontdesk.png";
import nurseSVG from "assets/img/outpatient.png";
import doctorSVG from "assets/svg/doctor.svg";
import labsSVG from "assets/img/labs.png";
import adminSVG from "assets/img/pharmacy.png";
import inventorySVG from "assets/img/inventory.png";
import reportingSVG from "assets/img/reports.png";
import {
  AUDIT_TRAIL_ACCESS,
  CENTRAL_STORE_ACCESS,
  MODULE_IDS,
  REPORT_ACCESS,
  SETTINGS_ADMIN_ACCESS,
  SUBSCRIPTIONS_ACCESS,
} from "config/access-control";

export const modules = [
  {
    _id: 1,
    avatar: frontDeskSVG,
    title: "Front Desk",
    key: MODULE_IDS.FRONTDESK,
    subtitle: "Manage all patients registration, appointment bookings and information",
    link: "/frontdesk",
  },
  {
    _id: 2,
    avatar: nurseSVG,
    title: "OutPatients",
    key: MODULE_IDS.OUT_PATIENT,
    subtitle: "Manage all consultation patients",
    link: "/out-patient",
  },
  {
    _id: 3,
    avatar: doctorSVG,
    title: "Doctor",
    key: "doctor",
    subtitle: "attend to patients and understand their health challenges",
    link: "#",
  },
  {
    _id: 4,
    avatar: labsSVG,
    title: "Laboratory",
    key: MODULE_IDS.LABORATORY,
    subtitle: "Manages all laboratory tests and results",
    link: "/laboratory",
  },
  {
    _id: 5,
    avatar: nurseSVG,
    title: "Pharmacy",
    key: MODULE_IDS.PHARMACY,
    subtitle: "Manage all Pharmacy items",
    link: "/pharmacy",
    isMigrated: true,
  },
  {
    _id: 6,
    avatar: inventorySVG,
    title: "Inventory",
    key: MODULE_IDS.INVENTORY,
    subtitle: "Manage the hospital inventory",
    link: "/inventory",
  },
  {
    _id: 7,
    avatar: adminSVG,
    title: "Admin Mgt",
    key: "admin",
    subtitle: "Manage the Activities of the hospital",
    link: "/settings",
    permissions: SETTINGS_ADMIN_ACCESS,
  },
  {
    _id: 8,
    avatar: adminSVG,
    title: "Central Store",
    key: "admin",
    subtitle: "Manage the Inventory Settings items of the hospital",
    link: "/inventory",
    permissions: CENTRAL_STORE_ACCESS,
  },
  {
    _id: 9,
    avatar: nurseSVG,
    title: "In Patients",
    key: MODULE_IDS.IN_PATIENT,
    subtitle: "Manage all consultation patients",
    link: "/in-patient",
  },
  {
    _id: 10,
    avatar: doctorSVG,
    title: "Billing",
    key: MODULE_IDS.BILLING,
    subtitle: "Manage all Finances",
    link: "/billing",
  },
  {
    _id: 11,
    avatar: labsSVG,
    title: "Admission",
    key: "admission",
    subtitle: "Manage all Admission items",
    link: "#",
  },
  {
    _id: 12,
    avatar: reportingSVG,
    title: "Reporting",
    key: MODULE_IDS.REPORT,
    subtitle: "Manage the staff and hospital activities",
    link: "/report",
  },
  {
    _id: 13,
    avatar: reportingSVG,
    title: "Reporting",
    key: "admin",
    subtitle: "Manage the staff and hospital activities",
    link: "/report",
    permissions: REPORT_ACCESS,
  },
  {
    _id: 14,
    avatar: reportingSVG,
    title: "Audit Trail",
    key: "admin",
    subtitle: "View and Manage Audit Trails in the System",
    link: "/audit-trail",
    permissions: AUDIT_TRAIL_ACCESS,
  },
  {
    _id: 15,
    avatar: reportingSVG,
    title: "Subscriptions",
    key: MODULE_IDS.SUBSCRIPTIONS,
    subtitle: "Manage subscriptions, SMS, and lab tracking",
    link: "/subscriptions",
  },
  {
    _id: 16,
    avatar: reportingSVG,
    title: "Subscriptions",
    key: "admin",
    subtitle: "Manage subscriptions, SMS, and lab tracking",
    link: "/subscriptions",
    permissions: SUBSCRIPTIONS_ACCESS,
  },
];

export const medicalStandards = [
  {
    _id: 1,
    url: "/symptoms",
    avatar: frontDeskSVG,
    title: "symptoms",
    subtitle: "Manage International Classification of Symptoms",
  },
  {
    _id: 2,
    url: "/diagnosis",
    avatar: labsSVG,
    title: "diagnosis",
    subtitle: "Create and Manage diagnosis information for your clinical records",
  },
];
